<template>
  <b-card style="border: 1px solid #ccc;">
    <h4 class="text-center">Informacion de MSP</h4>


    <!-- vista simplificada de msp -->


    <div 
      v-for="titular in itemsToMsp" 
      :key="titular.id"
    >

      <LoadFileInput
        v-model="titular.newMsp"
        :label="titular.nombre"
        :urlFile="titular.urlMsp"
      />

      <hr>
    </div>

    <div class="d-flex justify-content-end">

      <b-button 
        variant="success"
        @click="onSaveMsp"
        :disabled="disabledButtonUpdate"
      >
        Guardar Cambios
      </b-button>
    </div>
  </b-card>
</template>

<script>
import { titularService, fileService } from '@/shared/services';
import { LoadFileInput }  from '@/shared/components';
import { citasService }  from '../../services';

export default {

  name: "LoadMsp",


  props: {
    idPaciente: {
      type: String,
      required: true
    },

    tokenCita: {
      type: String,
      required: true
    }
  },

  components: {
    LoadFileInput
  },

  created() {
    this.lodaData();
  },

  data() {
    return {
      itemsToMsp: [],
      dataFilesToUpdate: null
    };
  },

  methods: {
    
    async lodaData(){
      const responseTitulares = await titularService.getTitularesByIdPaciente(this.idPaciente);
      const paciente = responseTitulares.titulares[0].paciente.persona;

      const personasToMsp = responseTitulares.titulares.map( t => t.persona );
      const pacienteMsp = personasToMsp.find( t => t.identificacion === paciente.identificacion );

      if(!pacienteMsp) personasToMsp.unshift(paciente);

      const responseCita = await citasService.getByToken(this.tokenCita);

      const urlMspMap = {
        0: responseCita.urlsMspPaciente,
        1: responseCita.urlsMspTitular1,
        2: responseCita.urlsMspTitular2,
        3: responseCita.urlsMspTitular3
      };

      this.itemsToMsp = personasToMsp.map( (t, index) => {

        return{
          identificacion: t.identificacion,
          nombre  : `${t.identificacion} - ${t.primerApellido} ${t.primerNombre}`,
          urlMsp  : urlMspMap[index],
          newMsp  : null,
          nTitular: index
        }
      });

    },


    prepararArchivosMsp(data){
      
      const mspPaciente = data.find( d => d.nTitular === 0 );
      const mspTitular1 = data.find( d => d.nTitular === 1 );
      const mspTitular2 = data.find( d => d.nTitular === 2 );
      const mspTitular3 = data.find( d => d.nTitular === 3 );

      this.dataFilesToUpdate = {
        mspPaciente: mspPaciente,
        mspTitular1: mspTitular1,
        mspTitular2: mspTitular2,
        mspTitular3: mspTitular3
      };

      this.$store.commit('setFiles', this.dataFilesToUpdate);
    },



    async onSaveMsp(){

      const response = await this.$swal({
        title: '¿Estas seguro?',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Si, guardar!',
        cancelButtonText: 'Cancelar'
      });

      if (!response.isConfirmed) return;

      let urlMspPaciente = null;
      let urlMspTitular1 = null;
      let urlMspTitular2 = null;
      let urlMspTitular3 = null;


      const { mspPaciente, mspTitular1, mspTitular2, mspTitular3 } = this.dataFilesToUpdate;

      if(mspPaciente)
        urlMspPaciente = await fileService.upload('mspCitas', mspPaciente.newMsp, mspPaciente.identificacion, mspPaciente.urlMsp);

      if(mspTitular1)
        urlMspTitular1 = await fileService.upload('mspCitas', mspTitular1.newMsp, mspTitular1.identificacion, mspTitular1.urlMsp);
      
      if(mspTitular2)
        urlMspTitular2 = await fileService.upload('mspCitas', mspTitular2.newMsp, mspTitular2.identificacion, mspTitular2.urlMsp);

      if(mspTitular3)
        urlMspTitular3 = await fileService.upload('mspCitas', mspTitular3.newMsp, mspTitular3.identificacion, mspTitular3.urlMsp);


      const itemsCitaToUpdate = {
        urlMspPaciente : urlMspPaciente,
        urlMspTitular1 : urlMspTitular1,
        urlMspTitular2 : urlMspTitular2,
        urlMspTitular3 : urlMspTitular3
      };

      const responseUpdate = await citasService.updateByToken(this.tokenCita, itemsCitaToUpdate);

      if(!responseUpdate) {
        this.$swal({
          title: "Error al actualizar Msp de la cita",
          icon: "error",
          confirmButtonColor: "#3085d6",
          confirmButtonText: "ok",
        });
        return;
      }

      await this.$swal({
        title: "Msp actualizado correctamente",
        icon: "success",
        confirmButtonColor: "#3085d6",
        confirmButtonText: "ok",
      });
      this.itemsToMsp = [];
      this.$router.go(0);
    }
  },


  computed: {

    disabledButtonUpdate(){
      return !this.itemsToMsp.find( d => d.newMsp );
    }
  },

  watch:{

    itemsToMsp: {
      deep: true,
      immediate: true,
      handler(newValue){
        this.prepararArchivosMsp(newValue);
      }
    }
  }
}
</script>
